import { LazyImage } from "../../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding";
import { Suspense, useCallback, useContext, useEffect, useRef, useState } from "react";
import ComponentLoader from "../../../../Shared/Sidebar/ComponentLoader";
import {
  getAlbum,
  getAlbumMediaImages,
  postCreateAlbum,
} from "../../Gallery/galleryService";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom";
import { TostMsg } from "../../../../App";
import ERROR_LIST from "../../../../Services/Global-Services/Hadle_Errors";

const EmployeeGallery = ({ employeeId, employee }) => {
  const [loading, setLoading] = useState(false);
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const history = useHistory();
  const [galleryLst, setgalleryLst] = useState([]);
  const mediaDefaultImage = "/images/no-data-found/feed_dummy.png";
  let userPermissions = JSON.parse(localStorage.getItem("Permissions") || "{}");
  const [galleryCreate, setGalleryCreate] = useState(false);
  const toster = useContext(TostMsg);
  const videoRef = useRef(null);
  const [posterSrc, setPosterSrc] = useState("");

  useEffect(() => {
    permissionAccouncementList();
    if (employeeId) {
      getAllDetailsMeadia();
    }
  }, [employeeId]);

  const permissionAccouncementList = () => {
    userPermissions.map((UserPermission) => {
      if (UserPermission.PermissionName == "Album.Create") {
        setGalleryCreate(true);
      }
    });
  };

  const getAllDetailsMeadia = async () => {
    let AlbumGUID;
    if (employee[0]?.AlbumGUID) {
      AlbumGUID = employee[0]?.AlbumGUID
    } else {
     AlbumGUID = ''
    }
    const param = {
      AlbumId: 0,
      LoggedInUserId: Number(userDetails?.EmpId),
      OrgId: Number(userDetails?.OrgId),
      AlbumMediaId: 0,
      PageNumber: 1,
      PageSize: 6,
      RecentPicture: 0,
      AlbumGUID: AlbumGUID,
    };
    try {
      const response = await getAlbumMediaImages(param);
      setgalleryLst(response?.Data?.orgAlbums);
    } catch (error) {
        toster.current.error(ERROR_LIST?.EmpPhoto);
    }
  };

  const PostCreateAlbum = async () => {
    const param = {
      Id: 0,
      OrgId: 0,
      EmpId: userDetails?.EmpId,
      Name: employee[0]?.FullName,
      Desc: `Moments shared by ${employee[0]?.FirstName} `,
    };
    try {
      const response = await postCreateAlbum(param);
      if (response?.Data?.GUID) {
        history.push(`/SingleGallery/${response?.Data?.GUID}`);
      }
      setgalleryLst(response?.Data?.orgAlbums);
    } catch (error) {
         toster.current.error(ERROR_LIST?.EmpPostPhoto);
    }
  };
  const handleImageError = useCallback((event) => {
    event.target.src = mediaDefaultImage;
  }, []);
  const galleryCreateAlbum = () => {
    if (employee[0]?.AlbumGUID) {
      history.push(`/SingleGallery/${employee[0]?.AlbumGUID}`);
    } else {
      PostCreateAlbum();
    }
  };


  const FeedCarouselTemplate = useCallback((media) => {
    let new_MediaPath = media?.MediaPath;
    const isVideo = new_MediaPath?.endsWith(".mp4") || new_MediaPath?.toLowerCase()?.endsWith(".mov");
    const mediaSrc = new_MediaPath || "";
    return isVideo ? (
      <video
        className="thankuimg0"
        ref={videoRef}
        src={mediaSrc}
        poster={posterSrc}
        playsInline
        muted
        controls={false}
      />
    ) : (
      <>
        {mediaSrc && (
          <img
            src={mediaSrc || mediaDefaultImage}
            onError={handleImageError}
            className="img-fit-cover"

          />
        )}
      </>
    );
  }, []);


  return (
    <div className="mb-4">
      {galleryLst?.length > 0 ? (
        <div className="form-head stuck-headers33 mt-4">
          <div className="form-head stuck-header profile-about-me">
            <div className="mb-0">
              <h4 className="text-primary mb-3 sumh4 addprofile-action">
                Photos
                {userDetails?.EmpId == employeeId && (
                  <span>
                    <a
                      onClick={() => galleryCreateAlbum()}
                      className="edit-btncss mb-2 love-icon"
                      data-toggle="tooltip"
                      data-placement="top"
                      title=""
                      data-bs-original-title="Add"
                      aria-label="Add"
                    >
                      <img
                        src="/images/org-img/profile/add.png"
                        className="w-100"
                      />
                    </a>
                  </span>
                )}
              </h4>

              <div className="row row-xxs pl-3 pr-3">
                {galleryLst?.slice(0, 5)?.map((el, index) => (
                  <div key={index} className="col-4">
                    <a className="d-block ht-60" href={`/SingleGallery/${employee[0]?.AlbumGUID}`}>
                      {FeedCarouselTemplate(el)}
                    </a>
                  </div>
                ))}

                {galleryLst?.length >= 5 && (
                  <div className="col-4">
                    <a
                      className="d-block ht-60 imgdiv lastimgdiv"
                      href={`/SingleGallery/${employee[0]?.AlbumGUID}`}
                    >
                      <img
                        src={galleryLst[5]?.MediaPath || mediaDefaultImage}
                        onError={handleImageError}
                        alt="More Media"
                      />
                      <div>
                        <span>
                          <a className="text-white">View more</a>
                        </span>
                      </div>
                    </a>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <>
          <div className="form-head stuck-headers33 mt-3">
            <div className="form-head stuck-header profile-about-me">
              <div className="mb-0">
                <h4 className="text-primary mb-3 sumh4 addprofile-action">
                  Photos
                  {(userDetails?.EmpId == employeeId || galleryCreate) && (
                    <span>
                      <a
                        onClick={() => galleryCreateAlbum()}
                        className="edit-btncss mb-2 love-icon"
                        data-toggle="tooltip"
                        data-placement="top"
                        title=""
                        data-bs-original-title="Add"
                        aria-label="Add"
                        style={{
                          background: "#fbfbfb",
                          float: "right",
                        }}
                      >
                        <img
                          src="/images/org-img/profile/add.png"
                          className="w-100"
                        />
                      </a>
                    </span>
                  )}
                </h4>
              </div>
            </div>
          </div>
        </>
      )}
      {loading ? (
        <Suspense>
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div>
  );
};
export default EmployeeGallery;